export const selectCurrentTheme = state => state.settings.currentTheme;
export const selectLanguage = state => state.settings.language;
